import { render, staticRenderFns } from "./certs.vue?vue&type=template&id=65f8d45a&scoped=true&"
import script from "./certs.vue?vue&type=script&lang=js&"
export * from "./certs.vue?vue&type=script&lang=js&"
import style0 from "./certs.vue?vue&type=style&index=0&id=65f8d45a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8d45a",
  null
  
)

export default component.exports